import { useRoleSwitch } from "../auth/useRoleSwitch";
import { roleLabel, roleSlug } from "../auth/roleMap";
import css from "./RoleMenu.module.css";

/**
 * Dropdown of the user's available roles. Anchored to a `position: relative`
 * header badge (the trigger lives in each header). Rendered only for
 * multi-role users; tapping an item switches role + routes to its dashboard.
 */
export function RoleMenu({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { roles, activeRole, switchTo } = useRoleSwitch();
  if (!open) return null;
  return (
    <>
      <div className={css.backdrop} onClick={onClose} aria-hidden="true" />
      <div className={css.menu} role="menu">
        {roles.map((r) => (
          <button
            key={r}
            type="button"
            role="menuitem"
            data-role={roleSlug(r)}
            className={`${css.item} ${r === activeRole ? css.active : ""}`}
            onClick={() => {
              switchTo(r);
              onClose();
            }}
          >
            <span className={css.dot} aria-hidden="true" />
            <span className={css.lbl}>{roleLabel(r)}</span>
            {r === activeRole ? <span className={css.now} aria-hidden="true">●</span> : null}
          </button>
        ))}
      </div>
    </>
  );
}
